import * as React from 'react';
import {Card, CardContent, CardMedia, Typography} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {Stack} from "@mui/system";


function MenuItemCard(props) {
  const {itemName, itemDescription, openPopup, img1, img2} = props

  return (
      <Card variant={'elevation'} elevation={5}>
        <CardMedia component="img" image={img1}/>
        <CardContent sx={{paddingTop: 1, marginBottom: -2}}>
          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={1}>
            <Typography align={'center'} fontSize={14}>
              {itemName}
            </Typography>
            <IconButton sx={{marginBottom: -2}} size={'small'} onClick={(ev) => openPopup(itemName, itemDescription, img2)}>
              <MoreHorizIcon fontSize={'medium'}/>
            </IconButton>
          </Stack>
        </CardContent>
      </Card>
  )
}

export { MenuItemCard }